import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFirebase } from 'react-redux-firebase';

import { useTheme } from '../../ThemeContext';

import {
  Item,
  ImageHolder,
  Video,
  VideoIcon,
  Image,
  Placeholder,
} from './AnnotationSequenceItem.style';

const AnnotationSequenceItem = ({
  data = {},
  isSelected = false,
  handleClick = () => {},
}) => {
  const theme = useTheme();
  const firebase = useFirebase();
  const [storageVideo, setStorageVideo] = useState(undefined);
  const [storageImage, setStorageImage] = useState(undefined);
  const [storageImageError, setStorageImageError] = useState(false);

  useEffect(() => {
    let didCancel = false;
    let didRecall = false;
    let recallId;
    if (data && (data.video_id || data.photo_id)) {
      const loadStorageMedia = async () => {
        try {
          if (data.video_id) {
            const storageVideo = await firebase
              .storage()
              .ref()
              .child(`waste_photos/${data.video_id}.mp4`)
              .getDownloadURL();
            if (!didCancel) setStorageVideo(storageVideo);
          } else if (data.photo_id) {
            const storageImage = await firebase
              .storage()
              .ref()
              .child(`waste_photos_thumbs/${data.photo_id}.jpg`)
              .getDownloadURL();
            if (!didCancel) setStorageImage(storageImage);
          }
        } catch {
          if (!didCancel) {
            if (!didRecall) {
              didRecall = true;
              recallId = setTimeout(() => loadStorageMedia(), 5000);
            } else setStorageImageError(true);
          }
        }
      };
      loadStorageMedia();
    }

    return () => {
      didCancel = true;
      if (storageVideo) setStorageVideo(undefined);
      if (storageImage) setStorageImage(undefined);
      if (storageImageError) setStorageImageError(false);
      if (recallId) clearTimeout(recallId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data && (data.video_id || data.photo_id)]);

  return (
    <Item
      theme={theme.annotationSequenceItem.item}
      isSelected={isSelected}
      onClick={(e) => {
        e.stopPropagation();
        handleClick(data);
      }}
    >
      <ImageHolder theme={theme.annotationSequenceItem.imageHolder}>
        {data.video_id || data.photo_id ? (
          storageVideo ? (
            <>
              <Video
                theme={theme.annotationSequenceItem.video}
                src={storageVideo}
                alt={data.video_id}
                loading='lazy'
              >
                <source src={storageVideo} type='video/mp4'></source>
              </Video>
              <VideoIcon
                theme={theme.annotationSequenceItem.videoIcon}
                className='material-icons'
              >
                play_circle_outline
              </VideoIcon>
            </>
          ) : storageImage ? (
            <Image
              theme={theme.annotationSequenceItem.image}
              src={storageImage}
              alt={data.photo_id}
              loading='lazy'
            />
          ) : storageImageError ? (
            <Placeholder className='material-icons'>
              image_not_supported
            </Placeholder>
          ) : (
            ''
          )
        ) : (
          <Placeholder className='material-icons'>
            image_not_supported
          </Placeholder>
        )}
      </ImageHolder>
    </Item>
  );
};

AnnotationSequenceItem.propTypes = {
  data: PropTypes.object,
  isSelected: PropTypes.bool,
  handleClick: PropTypes.func,
};

export default AnnotationSequenceItem;
